import { nonEmptyString } from '@atlassian/amkt-common';
import { Option } from 'funfix-core';
import { makeAppSpecificPassword, makeAppSpecificPasswordInstallMode } from '../../../records/InstallMode/AppSpecificPasswordInstallMode';
import getSPI from '../../../services/SPI';
import { makeGeneratedAppSpecificPassword } from '../../../types/GeneratedAppSpecificPassword';
import { doSetInstallMode } from '../Installation';
import { updateInstalledAppsPostInstall } from '../postInstallActions';
export const SET_APP_SPECIFIC_PASSWORD_NAME = 'INSTALLATION_SET_APP_SPECIFIC_PASSWORD_NAME';
export const START_GENERATE_APP_SPECIFIC_PASSWORD = 'INSTALLATION_START_GENERATE_APP_SPECIFIC_PASSWORD';
export const FINISH_GENERATE_APP_SPECIFIC_PASSWORD = 'INSTALLATION_FINISH_GENERATE_APP_SPECIFIC_PASSWORD';
export const GENERATE_APP_SPECIFIC_PASSWORD_ERROR = 'INSTALLATION_GENERATE_APP_SPECIFIC_PASSWORD_ERROR';
export const START_REGENERATE_APP_SPECIFIC_PASSWORD = 'INSTALLATION_START_REGENERATE_APP_SPECIFIC_PASSWORD';
export const FINISH_REGENERATE_APP_SPECIFIC_PASSWORD = 'INSTALLATION_FINISH_REGENERATE_APP_SPECIFIC_PASSWORD';
export const REGENERATE_APP_SPECIFIC_PASSWORD_ERROR = 'INSTALLATION_REGENERATE_APP_SPECIFIC_PASSWORD_ERROR';
export const setAppSpecificPasswordName = _ref => {
  let {
    name
  } = _ref;
  return {
    type: SET_APP_SPECIFIC_PASSWORD_NAME,
    name
  };
};
const startGenerateAppSpecificPassword = () => ({
  type: START_GENERATE_APP_SPECIFIC_PASSWORD
});
const finishGenerateAppSpecificPassword = _ref2 => {
  let {
    context,
    generatedAppSpecificPassword
  } = _ref2;
  return {
    type: FINISH_GENERATE_APP_SPECIFIC_PASSWORD,
    context,
    generatedAppSpecificPassword
  };
};
const generateAppSpecificPasswordError = _ref3 => {
  let {
    context,
    error
  } = _ref3;
  return {
    type: GENERATE_APP_SPECIFIC_PASSWORD_ERROR,
    context,
    error
  };
};
const startRegenerateAppSpecificPassword = _ref4 => {
  let {
    name,
    context
  } = _ref4;
  return {
    type: START_REGENERATE_APP_SPECIFIC_PASSWORD,
    name,
    context
  };
};
const finishRegenerateAppSpecificPassword = _ref5 => {
  let {
    context,
    generatedAppSpecificPassword
  } = _ref5;
  return {
    type: FINISH_REGENERATE_APP_SPECIFIC_PASSWORD,
    context,
    generatedAppSpecificPassword
  };
};
const regenerateAppSpecificPasswordError = _ref6 => {
  let {
    context,
    error
  } = _ref6;
  return {
    type: REGENERATE_APP_SPECIFIC_PASSWORD_ERROR,
    context,
    error
  };
};
export const doStartAppSpecificPasswordInstallMode = _ref7 => {
  let {
    name
  } = _ref7;
  return dispatch => {
    dispatch(doSetInstallMode({
      installMode: makeAppSpecificPasswordInstallMode({
        appSpecificPassword: name ? Option.of(makeAppSpecificPassword({
          name
        })) : Option.none()
      })
    }));
  };
};
export const doGenerateAppSpecificPassword = _ref8 => {
  let {
    name,
    context,
    hostConfig
  } = _ref8;
  return dispatch => {
    dispatch(startGenerateAppSpecificPassword());
    getSPI().createContainerToken({
      name,
      contextId: context.id
    }).then(tokenDetails => {
      dispatch(finishGenerateAppSpecificPassword({
        context,
        generatedAppSpecificPassword: makeGeneratedAppSpecificPassword(Option.of(tokenDetails.details.token).getOrElse('Unknown'))
      }));
      updateInstalledAppsPostInstall(dispatch, context, hostConfig);
    }, error => {
      dispatch(generateAppSpecificPasswordError({
        error,
        context
      }));
      console.error('createContainerToken was rejected by the SPI and returned the following error:', error);
    });
  };
};
export const doRegenerateAppSpecificPassword = _ref9 => {
  let {
    installedApp,
    context
  } = _ref9;
  return dispatch => {
    const name = nonEmptyString(installedApp.details.name);
    if (!name) {
      console.error('Existing app specific password in an invalid state - token name is empty');
      return;
    }
    dispatch(startRegenerateAppSpecificPassword({
      name,
      context
    }));
    getSPI().rotateContainerToken({
      addon: installedApp._original,
      contextId: context.id
    }).then(tokenDetails => {
      dispatch(finishRegenerateAppSpecificPassword({
        context,
        generatedAppSpecificPassword: makeGeneratedAppSpecificPassword(tokenDetails.token)
      }));
    }, error => {
      dispatch(regenerateAppSpecificPasswordError({
        context,
        error
      }));
      console.error('rotateContainerToken was rejected by the SPI and returned the following error:', error);
    });
  };
};